import React from 'react';
import { useNavigate } from 'react-router-dom';

const VerificationPending = () => {

    const navigate = useNavigate();

    const handleContinue = () => {
        localStorage.removeItem("employeeDetails");
        navigate('/retailerdashboard');
      };
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-14 rounded-3xl shadow-2xl text-center w-[600px] h-[450px]">
        <div className="mx-auto mb-8 w-24 h-24 bg-orange-100 rounded-[24px] flex items-center justify-center shadow-inner">
          <div className="flex gap-1">
            <span className="w-2.5 h-2.5 bg-orange-500 rounded-full"></span>
            <span className="w-2.5 h-2.5 bg-orange-500 rounded-full"></span>
            <span className="w-2.5 h-2.5 bg-orange-500 rounded-full"></span>
          </div>
        </div>
        <h2 className="text-3xl font-bold text-gray-800">Verification Pending</h2>
        <p className="text-lg text-gray-600 mt-4">
          We’re still working on it. Good things take time…..
        </p>
        <button
          onClick={handleContinue}
          className="mt-10 bg-orange-600 text-white px-10 py-3 rounded-lg hover:bg-orange-800 transition">
          Go To Dashboard
        </button>
      </div>
    </div>
  );
};

export default VerificationPending;
